var map = {
	"./tutorial_saba_1.png": 79498,
	"./tutorial_saba_2.png": 27,
	"./tutorial_saba_3.png": 62214,
	"./tutorial_saba_4.png": 13757,
	"./tutorial_saba_5.png": 14133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20779;